import { queryClient } from '@service-initiation/shared-utils-query-client';

import { GET_SERVICE_OPTIONS_CACHE_KEY } from '../getServiceOptions';

export const invalidateCachedServiceOptions = () =>
  queryClient.invalidateQueries({
    queryKey: [GET_SERVICE_OPTIONS_CACHE_KEY],
  });
